import { supabase } from "@/integrations/supabase/client";

interface GameResult {
  won: boolean;
  attempts: number;
  hintsUsed: number;
  currentStreak: number;
}

interface Achievement {
  id: string;
  name: string;
  description: string;
  icon: string;
  tier: string;
}

export async function checkAndAwardAchievements(
  userId: string,
  gameResult: GameResult
): Promise<Achievement[]> {
  try {
    // Fetch all achievement definitions
    const { data: allAchievements, error: achievementsError } = await supabase
      .from("achievements")
      .select("*");

    if (achievementsError) throw achievementsError;

    // Fetch user's existing achievements
    const { data: userAchievements, error: userAchievementsError } = await supabase
      .from("user_achievements")
      .select("achievement_id")
      .eq("user_id", userId);

    if (userAchievementsError) throw userAchievementsError;

    const earnedIds = new Set(userAchievements.map(ua => ua.achievement_id));
    const newlyEarned: Achievement[] = [];

    // Check each achievement using the secure SECURITY DEFINER function
    for (const achievement of allAchievements) {
      // Skip if already earned
      if (earnedIds.has(achievement.id)) continue;

      // Call the secure server-side function to check and award
      const { data: awarded, error } = await supabase.rpc('check_and_award_achievement', {
        p_achievement_id: achievement.id
      });

      if (error) {
        console.error(`Error checking achievement ${achievement.id}:`, error);
        continue;
      }

      // If awarded, add to newly earned list
      if (awarded === true) {
        newlyEarned.push(achievement);
      }
    }

    return newlyEarned;
  } catch (error) {
    console.error("Error checking achievements:", error);
    return [];
  }
}
